import PropTypes from 'prop-types';
import classNames from 'classnames';
import React, { forwardRef } from 'react';
import Tooltip from '@/componentsDS/Tooltip';
import { ButtonType } from './Button.type';

const BaseButton = forwardRef(
(
	{
		dataTestId = 'button',
		text,
		prefixIcon,
		suffixIcon,
		onClick,
		btnClassName,
		disabled,
		tooltipText,
		btnType,
		addbtnClass,
		fullWidth=false,
		id = undefined,
		...buttonProps
	},
	ref
) => {

	const buttonClass = classNames(
		'DS_button',
		btnType === ButtonType.UTILITY
			? 'DS__button-utility-wrapper'
			: 'button-wrapper',
		btnClassName,
		addbtnClass,
		{
			'DS_button--disabled': disabled
		}
	);

	return (
	<div className={buttonClass} data-testid={dataTestId}>
		<button
			ref={ref}
			onClick={onClick}
			onKeyUp={(e) => {
				if (btnType === ButtonType.UTILITY && e.key === ' ') {
					e.preventDefault();
				}
			}}
			disabled={disabled}
			{...buttonProps}
			type="button"
		>
			{prefixIcon && <span className="prefix-icon">{prefixIcon}</span>}
			{text && (
				<Tooltip
					id={tooltipText || ''}
					content={tooltipText || ''}
					disabled={!tooltipText}
					fullWidth={fullWidth}
				>
					<span className="button-text" id={id}>{text}</span>
				</Tooltip>
			)}
			{suffixIcon && <span className="suffix-icon">{suffixIcon}</span>}
		</button>
	</div>
	);
}
);

BaseButton.displayName = 'BaseButton';

BaseButton.propTypes = {
	dataTestId: PropTypes.string,
	text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	prefixIcon: PropTypes.node,
	suffixIcon: PropTypes.node,
	onClick: PropTypes.func,
	btnClassName: PropTypes.string,
	disabled: PropTypes.bool,
	tooltipText: PropTypes.string,
	btnType: PropTypes.oneOf(Object.values(ButtonType)).isRequired,
	addbtnClass: PropTypes.string,
	fullWidth: PropTypes.bool,
	id: PropTypes.string
};

export default BaseButton;
